@if(!sidenavHidden){
<div class="sidenav slide-in-blurred-top" [class.sidenav-collapsed]="collapsed">
  <div class="logo-container">
    <div class="d-flex align-items-center gap-2" *ngIf="collapsed" @fadeInOut>
      <!-- Optional: Logo here if needed -->
      <a class="navbar-brand d-flex align-items-center" [routerLink]="['/extranet']">
        <img src="assets/img/logo-previnca.svg" alt="previnca-seguros-logo" />
      </a>
    </div>

    <!-- Toggle Button -->
    <button class="logo" type="button" (click)="toggleCollapse()" [matTooltip]="collapsed ? 'Contraer' : 'Expandir'">
      <i class="fa-solid" [class.fa-arrow-left]="collapsed" [class.fa-bars]="!collapsed"></i>
    </button>
  </div>



  <ul class="sidenav-nav">
    @for (item of navData; track item.routeLink) {
    <li class="sidenav-nav-item">
      <a class="sidenav-nav-link" [routerLink]="[item.routeLink]" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }" [matTooltip]="!collapsed ? item.label : ''"
        matTooltipPosition="right">
        <i class="sidenav-link-icon" [class]="item.icon"></i>
        <span class="sidenav-link-text" *ngIf="collapsed" @fadeInOut>{{ item.label }}</span>
      </a>
    </li>
    }

    <!-- Configuration Link (as part of menu) -->
    <li class="sidenav-nav-item mt-auto">
      <a class="sidenav-nav-link" [routerLink]="['/extranet/configuracion']" routerLinkActive="active"
        [matTooltip]="!collapsed ? 'Configuración' : ''" matTooltipPosition="right">
        <i class="sidenav-link-icon text-center fa-solid fa-gear"></i>
        <span class="sidenav-link-text" *ngIf="collapsed" @fadeInOut>Configuración</span>
        <span *ngIf="faltanDatos && collapsed" class="badge bg-warning text-dark ms-2">Faltan datos</span>
        <i *ngIf="faltanDatos && !collapsed" class="fa-solid fa-circle-exclamation text-warning ms-1"></i>
      </a>
    </li>

    <li class="sidenav-nav-item">
      <button class="sidenav-nav-link w-100 border-0 bg-transparent" (click)="logout()"
        [matTooltip]="!collapsed ? 'Cerrar Sesión' : ''" matTooltipPosition="right">
        <i class="sidenav-link-icon fa-solid fa-right-from-bracket text-danger"></i>
        <span class="sidenav-link-text text-danger" *ngIf="collapsed" @fadeInOut>Cerrar Sesión</span>
      </button>
    </li>
  </ul>
  <div class="user-profile-section" *ngIf="collapsed" @fadeInOut>
    @if(usuario?.img && !imgError) {
    <img class="img-perfil" [src]="'../' + usuario.img" (error)="imgError = true" alt="Foto de perfil" />
    } @else {
    <div class="img-perfil d-flex align-items-center justify-content-center bg-light">
      <i class="fa-solid fa-user fs-1 text-secondary"></i>
    </div>
    }
    <div>

      <p class="text-start m-0 mt-2 lh-sm fw-bold">{{ usuario?.['Ident-Usuario'] || 'Usuario' }}</p>
      <p class="text-start m-0 lh-sm fw-light text-muted small">{{ usuario?.email }}</p>
    </div>
  </div>
  <!-- EX2-319: link a la extranet anterior (EX2-214), siempre disponible acá, sutil -->
  <a *ngIf="collapsed" @fadeInOut class="link-extranet-vieja mb-3 mx-auto" href="https://extranet.previncaseguros.com.ar"
    target="_blank" rel="noopener noreferrer">
    Ir a la Extranet anterior →
  </a>
</div>
} @else{

<nav class="navbar navbar-expand-lg">
  <div class="container-fluid">
    <a class="navbar-brand d-flex align-items-center" [routerLink]="['/extranet']">
      <img src="assets/img/logo-previnca.svg" alt="previnca-seguros-logo" />
    </a>

    <button class="navbar-toggler" type="button" (click)="isNavOpen = !isNavOpen">
      <i class="fa-solid fa-bars"></i>
    </button>

    <div class="navbar-collapse collapse" [class.show]="isNavOpen">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <!-- User Info Mobile -->
        <li class="nav-item border-bottom mb-2 pb-2" *ngIf="usuario">
          <div class="d-flex align-items-center gap-2 px-2">
            @if(usuario?.img && !imgError) {
            <img class="img-perfil" style="width: 40px; height: 40px; border: 1px solid #ddd;"
              [src]="'../' + usuario.img" (error)="imgError = true" alt="Foto de perfil" />
            } @else {
            <div class="img-perfil d-flex align-items-center justify-content-center bg-light"
              style="width: 40px; height: 40px; border: 1px solid #ddd;">
              <i class="fa-solid fa-user text-secondary"></i>
            </div>
            }
            <div>
              <p class="m-0 fw-bold small">{{ usuario?.['Ident-Usuario'] }}</p>
              <p class="m-0 text-muted small" style="font-size: 0.75rem;">{{ usuario?.email }}</p>
            </div>
          </div>
          <!-- EX2-319: link a la extranet anterior (EX2-214), siempre disponible acá, sutil -->
          <a class="link-extranet-vieja mt-2 mx-2" href="https://extranet.previncaseguros.com.ar" target="_blank"
            rel="noopener noreferrer">
            Ir a la Extranet anterior →
          </a>
        </li>

        @for (item of navData; track item.routeLink) {
        <li class="nav-item">
          <a class="nav-link" [routerLink]="[item.routeLink]" routerLinkActive="active" (click)="isNavOpen = false">
            <i class="sidenav-link-icon" [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </a>
        </li>
        }
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/extranet/configuracion']" (click)="isNavOpen = false">
            <i class="sidenav-link-icon fa-solid fa-gear"></i>
            <span>Configuración</span>
            <span *ngIf="faltanDatos" class="badge bg-warning text-dark ms-2">Faltan datos</span>
          </a>
        </li>
        <li class="nav-item mt-2 pt-2 border-top">
          <button class="nav-link w-100 text-start text-danger" (click)="logout()">
            <i class="sidenav-link-icon fa-solid fa-right-from-bracket"></i>
            <span>Cerrar Sesión</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Backdrop for mobile menu -->
<div class="modal-backdrop fade show" *ngIf="isNavOpen && !sidenavHidden" (click)="isNavOpen = false"
  style="z-index: 999;"></div>

}